import { render, staticRenderFns } from "./InputableText.vue?vue&type=template&id=70af1edb&scoped=true&"
import script from "./InputableText.ts?vue&type=script&lang=ts&"
export * from "./InputableText.ts?vue&type=script&lang=ts&"
import style0 from "./InputableText.css?vue&type=style&index=0&id=70af1edb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70af1edb",
  null
  
)

export default component.exports